import { ActionTree } from 'vuex';
import {
  EUpdateDocumentAction,
  EUpdateDocumentMutation,
  IUpdateDocumentState,
} from './update-document.types';
import { getDefaultState } from './update-document.constants';
import { RootState } from '@/store/store';
import { IDocumentPage } from '@lib-shared/types/document-page';
import { IDocument } from '@lib-shared/types/Document';
import { DocumentService } from '@/api/documents/services/document.service';

export const actions: ActionTree<IUpdateDocumentState, RootState> = {
  async [EUpdateDocumentAction.UpdatePageOrder](
    { commit, dispatch },
    { document, rearrangedPages }: { document: IDocument; rearrangedPages: IDocumentPage[] }
  ) {
    commit(EUpdateDocumentMutation.SetOriginalDocument, document);
    commit(EUpdateDocumentMutation.SetUpdating, true);
    commit(EUpdateDocumentMutation.SetUpdateFailed, false);
    commit(EUpdateDocumentMutation.SetUpdatedDocument, getDefaultState().updatedDocument);

    const pageIds: string[] = rearrangedPages.map((page: IDocumentPage) => page.id);
    const pageNums: number[] = rearrangedPages.map((page: IDocumentPage) => page.pageNum);

    try {
      await DocumentService.sortDocumentPages(document.id, pageIds, pageNums);
      dispatch(EUpdateDocumentAction.UpdatePageOrderSuccess, {
        ...document,
        pages: rearrangedPages,
      });
    } catch (e) {
      dispatch(EUpdateDocumentAction.UpdatePageOrderFailed, e);
    }
  },
  [EUpdateDocumentAction.UpdatePageOrderSuccess]({ commit }, document: IDocument) {
    commit(EUpdateDocumentMutation.SetUpdatedDocument, document);
    commit(EUpdateDocumentMutation.SetUpdating, false);
  },
  [EUpdateDocumentAction.UpdatePageOrderFailed]({ commit }, e: Error) {
    commit(EUpdateDocumentMutation.SetUpdateFailed, true);
    commit(EUpdateDocumentMutation.SetUpdating, false);
    console.error(e);
  },
  [EUpdateDocumentAction.Reset]({ commit }) {
    commit(EUpdateDocumentMutation.SetState, getDefaultState());
  },
};
